"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var BufferFullnessExit_1 = require("./Constants/BufferFullnessExit");
function updateVariantRebuffer(params) {
    var abrState = params.abrState, metrics = params.metrics, setCurrentVariantIndex = params.setCurrentVariantIndex;
    var bufferDepth = metrics.bufferedDuration.min;
    var bandwidthEstimate = metrics.bandwidthEstimate;
    var variants = abrState.variants;
    // use 50% of customer bandwidth when buffer is empty, rising to 80% of customer bandwidth
    // when buffer has 10 seconds
    //
    // note: we want to under-utilise customer bandwidth while re-buffering so that we choose
    //       smaller fragments that we can download quickly
    var bufferFullness = bufferDepth / BufferFullnessExit_1.default.REBUFFER_TO_STEADY;
    var customerBandwidthUsage = Math.min(0.8, 0.5 + (0.3 * bufferFullness));
    var modifiedBandwidthEstimate = bandwidthEstimate * customerBandwidthUsage;
    var variantIndex;
    for (variantIndex = 0; variantIndex < variants.length; variantIndex++) {
        if (variants[variantIndex].bandwidth <= modifiedBandwidthEstimate) {
            break;
        }
    }
    variantIndex = Math.min(variantIndex, variants.length - 1);
    setCurrentVariantIndex(variantIndex);
}
exports.default = updateVariantRebuffer;
//# sourceMappingURL=updateVariantRebuffer.js.map